export const globalTheme = {
  background: "#f2f4f8",
  primaryColor: "#595c97",
  secondaryColor: "#a1a1c2",
  activeMenu: "#0071e3",
  white: "#ffffff",
  border: "#e4e9f0",
  blue: "#03a9f4",
  orange: "#ff9800",
  green: "#8bc34a",
  red: "#f5222e",
};
